<template>
  <div class="d-inline-block">
    <div style="height: 20px;">
      <vc-share-a href="https://translate.google.com/">
        <img
          v-if="displayingTranslationText"
          class="buttonImage"
          src="./assets/translated_by_google_grayscale.png"
          style="height: 20px;"
        />
      </vc-share-a>
    </div>
    <div>
      <img
        class="buttonImage"
        src="./assets/google_logo.png"
        style="vertical-align: middle; width: 15px; height: 15px;"
      />
      <a
        style="vertical-align: middle;"
        v-on="{
          click: displayingTranslationText
            ? displayOriginalText
            : displayTranslatedText
        }"
      >
        {{
          displayingTranslationText
            ? this.lang.show_original_text
            : this.lang.show_translation_text
        }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "vc-share-comment-translation-button",
  data: () => ({
    displayingTranslationText: true
  }),
  props: {
    lang: {
      type: Object,
      default: () => {
        return {
          show_original_text: "原文で見る",
          show_translation_text: "Googleで翻訳"
        };
      }
    },
    commentId: {
      type: Number,
      default: 0
    },
    getCommentOriginalText: {
      type: Function,
      default: () => {}
    },
    getCommentTranslatedText: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    displayOriginalText: function() {
      let thisObject = this;
      this.getCommentOriginalText(this.commentId).then(function(value) {
        if (value === 0) {
          thisObject.displayingTranslationText = false;
        }
      });
    },
    displayTranslatedText: function() {
      let thisObject = this;
      this.getCommentTranslatedText(this.commentId).then(function(value) {
        if (value === 0) {
          thisObject.displayingTranslationText = true;
        }
      });
    }
  }
};
</script>
